import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/suggestPrivateClients', request, cancelToken)
}

export {get}
